import { MousePointer } from 'lucide-react';

export const GAME_INFO: GameInfo = {
  id: 1,
  title: 'Clica',
  description: '',
  instructions: [
    'Clica els cercles per avançar de ronda i tria entre 1 i 4 cercles.',
    'Necessites entre 3 i 12 clics per completar la ronda.',
    'Acaba amb 5, 10, 15 o 20 cercles actius. Clica ràpidament!',
    'Cada ronda és una oportunitat per millorar els teus reflexos.',
  ],
  icon: MousePointer,
  path: '/clica',
  category: 'Arcade',
  localStorageKey: 'clickGameStats',
  customStatLabel: 'Clics Totals',
  customStatLabelSingular: 'Clics',
  defaultGameMode: 'two',
  gameModeTitle: 'Selecciona els Cercles',
  gameModes: [
    {
      id: 'one',
      name: '1 Cercle',
    },
    {
      id: 'two',
      name: '2 Cercles',
    },
    {
      id: 'three',
      name: '3 Cercles',
    },
    {
      id: 'four',
      name: '4 Cercles',
    },
  ],
};
